import { render, staticRenderFns } from "./MessageTemplateFormDialog.vue?vue&type=template&id=09a6c5ef&scoped=true"
import script from "./MessageTemplateFormDialog.vue?vue&type=script&lang=js"
export * from "./MessageTemplateFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6c5ef",
  null
  
)

export default component.exports